import once from 'lodash/once'

declare global {
  const zE: any
  const $zopim: any
}
/**
 * Loads Zendesk.
 */
export const loadZendesk = once(function loadZendesk(key, department) {
  /* eslint-disable */
  const w = window as any
  const d = document
  const s = d.createElement('script')
  s.type = 'text/javascript'
  s.id = 'ze-snippet'
  s.async = true
  s.src = 'https://static.zdassets.com/ekr/snippet.js?key=' + key

  if (department !== '') {
    s.onload = function () {
      zE(function () {
        $zopim(function () {
          $zopim.livechat.departments.setVisitorDepartment(department)
          $zopim.livechat.departments.filter(department)
          $zopim.livechat.setOnConnected(function () {
            let previous_status: string
            $zopim.livechat.setOnStatus(function () {
              const new_status =
                $zopim.livechat.departments.getDepartment(department).status
              if (!previous_status || new_status !== previous_status) {
                if (new_status !== 'offline') {
                  $zopim.livechat.setStatus('online')
                } else {
                  $zopim.livechat.setStatus('offline')
                }
                previous_status = new_status
              }
            })
          })
        })
      })
    }
  }

  const x = d.getElementsByTagName('script')[0] as any
  x.parentNode.insertBefore(s, x)
})
